document.addEventListener('DOMContentLoaded', () => {
  /**
   * Shopify Forms app renders inside Shadow DOM (<shopify-forms-embed>).
   * Standard querySelector cannot pierce shadow boundaries, so we
   * traverse into the shadow root to find the form and phone input.
   */

  const getFormElements = () => {
    const embed = document.querySelector('shopify-forms-embed');
    if (!embed?.shadowRoot) return null;

    const form = embed.shadowRoot.querySelector('form');
    if (!form) return null;

    const phoneInput = form.querySelector('input[type="tel"]');
    if (!phoneInput) return null;

    const submitBtn = form.querySelector('button[type="submit"]');
    if (!submitBtn) return null;

    return { form, phoneInput, submitBtn };
  };

  const attachTracker = ({ phoneInput, submitBtn }) => {
    console.log('Appointment form detected — attaching tracking');
    const pushDataLayer = () => {
      const phone = phoneInput.value.trim().replace(/[\s\-()]/g, '');
      if (!phone) return;

      const formattedPhone = phone.charAt(0) !== '+' ? `+${phone}` : phone;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ec_form_submit',
        user_data: {
          phone_number: formattedPhone,
        },
      });
      console.log('dataLayer pushed — ec_form_submit, phone:', formattedPhone);
    };

    submitBtn.addEventListener('click', pushDataLayer);
  };

  const elements = getFormElements();
  if (elements) {
    attachTracker(elements);
    return;
  }

  /* Shopify Forms app loads asynchronously — poll until the shadow root is ready */
  const interval = setInterval(() => {
    const elements = getFormElements();
    if (elements) {
      clearInterval(interval);
      attachTracker(elements);
    }
  }, 500);

  /* Safety cleanup if the form never renders */
  setTimeout(() => clearInterval(interval), 15000);
});
